export default function ({children, style={}}) {
    const fontFamily = window.location.pathname.includes('/app/report') ? 'Calibri' : 'Segoe ui'
    const fontSize = window.location.pathname.includes('/app/report') ? '11pt' : '9pt'

    return (
        <div style={{ fontSize: fontSize, fontFamily: fontFamily, ...style }}>
            {children}
        </div>
    );
}